import makeStyles from "e100-react-components/lib/styles/makeStyles";

export const useStyles = makeStyles(({ palette }) => ({
  input: {
    "-webkit-appearance": "none",
    width: "100%",
    background: palette.primary.light,
    borderRadius: "4px",
    height: "4px",
    backgroundImage: `linear-gradient(${palette.primary.main}, ${palette.primary.main})`,
    backgroundSize: "0% 100%",
    backgroundRepeat: "no-repeat",

    "&::-webkit-slider-thumb": {
      "-webkit-appearance": "none",
      height: "16px",
      width: "16px",
      borderRadius: "50%",
      background: palette.primary.main,
      cursor: "pointer",
      boxShadow: "0px 2px 3px 0px #24262C29",
      transition: "background .3s ease-in-out",
    },
    // "&::-webkit-slider-runnable-track": {
    //   "-webkit-appearance": "none",
    //   boxShadow: "none",
    //   borderBottom: `4px solid ${palette.primary.light}`,
    //   height: "10px",
    // },
  },
}));
